$(function () {
  if ($(window).width() < 767) {
    $(window).scroll(function () {

      var defaultButton = $("#default-button");
      if(defaultButton.length > 0){
        
     

      var top_of_element = $("#default-button").offset().top;
      var bottom_of_element =
        $("#default-button").offset().top + $("#default-button").outerHeight();
      var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
      var top_of_screen = $(window).scrollTop();

      if (
        bottom_of_screen > top_of_element &&
        top_of_screen < bottom_of_element
      ) {
        // the element is visible, do something
        $("body").removeClass("show-sticky");
        // $("#default-button").show();
        $("#sticky-buttons").css("display", "none");
      } else {
        $("body").addClass("show-sticky");
        // $("#default-button").hide();
        $("#sticky-buttons").css("display", "flex");
      }
      
    }


    });
  }

  $("span.qty-plus").on("click", function () {
    var qty = parseInt($("input.product-qty").val());
    $("input.product-qty").val(qty + 1);
    var new_qty = parseInt($("input.product-qty").val());
    $(".quantity__input").val(new_qty);
  });

  $("span.qty-minus").on("click", function () {
    var qty = parseInt($("input.product-qty").val());
    if (qty > 1) {
      $("input.product-qty").val(qty - 1);
      var new_qty = parseInt($("input.product-qty").val());
      $(".quantity__input").val(new_qty);
    }
  });
  $("a.child-nav-title").on("click", function () {
    $(this).next().slideToggle();
  });
});

$(document).ready(function () {
  $(".customers-wrap").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    prevArrow:
      '<button class="slide-arrow prev-arrow"><img src="' +
      slider_arrow +
      '"></button>',
    nextArrow:
      '<button class="slide-arrow next-arrow"><img src="' +
      slider_arrow +
      '"></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "20px",
        },
      },
    ],
  });
  $(".products-wrapp").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    mobileFirst: true,
    prevArrow:
      '<button class="slide-arrow prev-product-arrow"><img src="' +
      arrow +
      '"></button>',
    nextArrow:
      '<button class="slide-arrow next-product-arrow"><img src="' +
      arrow +
      '"></button>',

    responsive: [
      {
        breakpoint: 767,
        settings: "unslick",
      },
    ],
  });
  $(".products-wrap").on("init", function (event, slick) {
    $(this).append(
      '<div class="slider-count"><p><span id="current">1</span>/<span id="total">' +
      slick.slideCount +
      "</span></p></div>"
    );
  });
  $(".products-wrap").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    mobileFirst: true,
    prevArrow:
      '<button class="slide-arrow prev-product-arrow"><img src="' +
      arrow +
      '"></button>',
    nextArrow:
      '<button class="slide-arrow next-product-arrow"><img src="' +
      arrow +
      '"></button>',
    responsive: [
      {
        breakpoint: 767,
        settings: "unslick",
      },
    ],
  });
  $(".products-wrap").on("afterChange", function (event, slick, currentSlide, nextSlide) {
    // finally let's do this after changing slides
    $(".slider-count #current").html(currentSlide + 1);
  }
  );
  $(".single-product-rating a, .customers-btn").on("click", function (event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;

      $("html, body").animate(
        {
          scrollTop: $(hash).offset().top,
        },
        800,
        function () {
          window.location.hash = hash;
        }
      );
    }
  });

  // monster-upsell-cart JS
  function checkCartItem() {
    if ($("#monster-upsell-cart .mu-cart-item").length !== 0) {
      // console.log(".mu-cart-item GET == ", $("#monster-upsell-cart .mu-cart-item").length)
      $("#monster-upsell-cart .mu-cart-item").parent().addClass("cart_product_block");
      if ($(".mu-cart-item .mu-font-bold a").length !== 0) {
        $(".mu-cart-item .mu-font-bold a").each(function (item) {
          if ($(this).text() == "Build Your Own Bundle") {
            // console.log("Product Get");
            $("#monster-upsell-cart .mu-frequently-container, #monster-upsell-cart .mu-atu-banner").hide()
          } else {
            // console.log("Not This Product");
            $("#monster-upsell-cart .mu-frequently-container, #monster-upsell-cart .mu-atu-banner").show()
          }
        });
      }
      clearInterval(timer);
    } else {
      // console.log(".mu-cart-item Not Get == ", $("#monster-upsell-cart .mu-cart-item").length);
    }
  }
  function setEventInCart() {
    if ($("#monster-upsell-cart").length !== 0) {
      // console.log("#monster-upsell-cart Get == ", $("#monster-upsell-cart").length);
      checkCartItem()
      var target = document.querySelector('#monster-upsell-cart');
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          checkCartItem()
        });
      });
      var config = { attributes: false, childList: true, subtree: true };
      observer.observe(target, config);
    } else {
      // console.log("#monster-upsell-cart Not Get == ", $("#monster-upsell-cart").length);
    }
  }
  var timer = setInterval(function () {
    setEventInCart()
  }, 2000);

});
